import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getProjectTasks } from 'api/tasksList'

export const getProjectTasksAction = createAsyncThunk(
  'tasksList/getProjectTasks',
  async (data, { rejectWithValue }) => {
    const response = await getProjectTasks(data.slug, data, data.controller)

    if ((response?.status || response?.code) >= 400) {
      return rejectWithValue({
        status: response?.status || response?.code,
        message: response?.data?.message || response?.errorMessage,
        data: response?.data || null,
      })
    }

    return response
  }
)

const tasksListSlice = createSlice({
  name: 'tasksList',
  initialState: {
    getProjectTaskStatus: 'idle',
    tasks: [],
    meta: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getProjectTasksAction.pending, (state) => {
        state.getProjectTaskStatus = 'pending'
        state.error = null
      })
      .addCase(getProjectTasksAction.fulfilled, (state, action) => {
        state.getProjectTaskStatus = 'success'
        state.tasks = Array.isArray(action.payload?.data)
          ? action.payload.data
          : []
        state.meta = action.payload?.meta || null
        state.error = null
      })
      .addCase(getProjectTasksAction.rejected, (state, action) => {
        state.getProjectTaskStatus = 'error'
        state.tasks = []
        state.meta = null
        state.error = action.payload || null
      })
  },
})

export const tasksListSelector = (state) => state.tasksList.tasks
export const tasksListMetaSelector = (state) => state.tasksList.meta
export const tasksListStatusSelector = (state) =>
  state.tasksList.getProjectTaskStatus
export const tasksListErrorSelector = (state) => state.tasksList.error

export default tasksListSlice.reducer
